import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { CoreModule, HttpService } from '@app/core';
import { SharedModule } from '@app/shared';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MenuModule } from './pages/menu/menu.module';
import { HttpErrorsModule } from './pages/http-errors/http-errors.module';
import { ConfigurationModule } from './pages/configurations/configuration.module';
import { AuthModule } from './pages/auth/auth.module';
import { OAuthModule } from './pages/oauth/oauth.module';
import { DocumentsModule } from './pages/documents/documents.module';
import { InvoicesModule } from './pages/invoices/invoices.module';
import { AuditModule } from './pages/audit/audit.module';
import { StylesheetModule } from '@app/pages/stylesheet/stylesheet.module';
import { WhitelabelModule } from './pages/whitelabel/whitelabel.module';
import { HelpersModule } from '@app/pages/helpers/helpers.module';

import { provideNamedApollo } from 'apollo-angular';
import { createApolloClients } from './graphql.providers';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: false }), // { enabled: environment.production }
    FormsModule,
    TranslateModule.forRoot(),
    NgbModule,
    NgxDaterangepickerMd.forRoot(),
    CoreModule,
    SharedModule,
    HttpErrorsModule,
    AuditModule,
    AuthModule,
    OAuthModule,
    ConfigurationModule,
    DocumentsModule,
    MenuModule,
    InvoicesModule,
    StylesheetModule,
    WhitelabelModule,
    HelpersModule,
    Angulartics2Module.forRoot(),
    AppRoutingModule // must be imported as the last module as it contains the fallback route
  ],
  providers: [{ provide: HttpClient, useClass: HttpService }, provideNamedApollo(() => createApolloClients()), provideEnvironmentNgxMask()]
})
export class AppModule {
  constructor() {}
}
